import type { CCompanyDigitalizationTranslations } from "./pl";

export const en: CCompanyDigitalizationTranslations = {
  emptyData: "No data to display.",
  emptyList: "No child catalogs to display.",
  readMore: "Learn more",
};
